import gql from "graphql-tag";

export const SEND_INVITE = gql`
  mutation ($email: [String!]!) {
    sendReferralInvite(input: { email: $email }) {
      success
    }
  }
`;
